// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProjectHeadVO } from '@project/model/vo/project.vo';
import { CustomValidators } from '@shared/custom-validators';
import { ProjectOptionUtils } from '../util/project-option.utils';
import { EditProjectService } from '@project/components/project/service/edit-project.service';

@Component({
  standalone: false,
  selector: 'edit-project-name',
  templateUrl: './edit-project-name.component.html',
})
export class EditProjectNameComponent implements OnInit {
  @Input() project: ProjectHeadVO;
  @Input() isArticleProject: boolean = false;
  @Output() public finish = new EventEmitter<boolean | undefined>();

  public form: FormGroup;
  public readonly projectNameFormItemName = 'projectName';

  constructor(private formBuilder: FormBuilder, private bsModalRef: BsModalRef, private editProjectService: EditProjectService) { }

  public ngOnInit(): void {
    const formData: any = {};
    formData[this.projectNameFormItemName] = [this.project.name,
      Validators.compose([
        CustomValidators.projectNameValidator(false),
        CustomValidators.trimRequired,
        CustomValidators.maxLength(ProjectOptionUtils.MAX_PROJECT_NAME_LENGTH),
      ])];
    this.form = this.formBuilder.group(formData);
  }

  public onSave(): void {
    if (!this.form.valid) {
      return;
    }

    const newOptionName: string = this.form.controls[this.projectNameFormItemName].value;
    this.editProjectService.renameProject(this.project, this.isArticleProject, newOptionName).subscribe(
      (success: boolean) => this.onCancel(success),
      (error: any) => this.onCancel()
    );
  }

  public onCancel(success?: boolean): void {
    this.bsModalRef.hide();
    this.finish.emit(success);
  }
}
